// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f0c8a7a6","703":"87b04fde"}[chunkId] + ".chunk.js";
};